import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Play = createIcon({
  displayName: "Play",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M17.9311 11.1175C18.386 11.3734 18.6135 11.5013 18.7058 11.6592C18.8289 11.8697 18.8289 12.1303 18.7058 12.3408C18.6135 12.4986 18.386 12.6266 17.9311 12.8825L8.75738 18.0427C8.39087 18.2489 8.20762 18.3519 8.05775 18.3507C7.85792 18.349 7.67398 18.2414 7.57455 18.0681C7.49997 17.9381 7.49997 17.7278 7.49997 17.3073L7.49997 6.69268C7.49997 6.27216 7.49997 6.06191 7.57455 5.9319C7.67398 5.75856 7.85792 5.65098 8.05775 5.6493C8.20762 5.64804 8.39087 5.75112 8.75738 5.95729L17.9311 11.1175Z"
    />
  )
});
